import React from 'react';
const pains = [{
  emoji: '😰',
  title: 'Constant Lesson Planning',
  description: 'You spend hours every week trying to create new classes that are safe, engaging, and appropriate for different swimming levels — from complete beginners to advanced swimmers.'
}, {
  emoji: '⚠️',
  title: 'Fear of Doing Too Much... or Too Little',
  description: 'You constantly wonder if a drill is too advanced, too simple, or not appropriate for the students in front of you — especially in mixed-level groups.'
}, {
  emoji: '📚',
  title: 'Information Everywhere',
  description: 'You find drills and exercises online, but nothing is organised into a complete coaching system you can actually follow poolside with confidence.'
}, {
  emoji: '😩',
  title: 'Mental Exhaustion',
  description: 'Between planning lessons, coaching technique, managing groups, and communicating with parents, you have little time left to focus on what truly matters: helping people swim better.'
}];
export function PainSection() {
  return <section className="py-8 px-4 sm:px-6 bg-brand-gray" data-id="element-119">
      <h2 className="text-2xl sm:text-3xl font-heading font-black text-center text-brand-navy mb-2 uppercase leading-tight" data-id="element-120">
        DO YOU RECOGNIZE THIS?
      </h2>

      <p className="text-sm sm:text-base text-brand-navy font-medium text-center mb-6 leading-snug max-w-xl mx-auto" data-id="element-121">
        You love teaching people to swim, but does planning consume your entire
        week?
        <br data-id="element-122" />
        <span className="text-brand-pool font-bold mt-1 block" data-id="element-123">
          If you work as a swim instructor, you probably know one of these
          situations:
        </span>
      </p>

      <div className="flex flex-col gap-3" data-id="element-124">
        {pains.map((pain, i) => <div key={i} className="bg-white p-4 rounded-md border-l-4 border-brand-pool shadow-sm flex gap-3 items-start" data-id="element-125">
            <div className="text-2xl leading-none shrink-0 mt-0.5" data-id="element-126">
              {pain.emoji}
            </div>
            <div data-id="element-127">
              <h3 className="text-sm font-bold text-brand-navy mb-1 uppercase tracking-tight" data-id="element-128">
                {pain.title}
              </h3>
              <p className="text-brand-navy/80 text-sm leading-snug" data-id="element-129">
                {pain.description}
              </p>
            </div>
          </div>)}
      </div>
    </section>;
}